import React from "react";
import { Route, withRouter, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { compose, lifecycle } from "recompose";

import Dialogs from "../components/dialogs";
import Navigation from "./Navigation";
import Main from "./Main";
import ProjectNew from "./ProjectNew";
import Project from "./Project";
import Projects from "./Projects";
import RequestDetail from "./RequestDetail/RequestDetail";
import RequestNew from "./RequestNew";
import RequestReceived from "./RequestReceived";
import RequestsMe from "./RequestsMe";
import RequestsOther from "./RequestsOther";
import Contacts from "./Contacts";
import Settings from "./Settings";
import Page from "./Page";
import Person from "./Person";
import OrganizationNew from "./OrganizationNew";
import SuppliersInvite from "./SuppliersInvite";
import Hosts from "./Hosts";
import UserOrganizations from "./UserOrganizations";
import HostFound from "./HostFound";
import ServerFound from "./ServerFound";
import OrganizationFound from "./OrganizationFound";
import RemoveHost from "./RemoveHost";
import RemoveServer from "./RemoveServer";
import RemoveOrganization from "./RemoveOrganization";
import PackageNew from "./PackageNew";
import ActivateAccount from "./ActivateAccount";
import Resources from "./Resources";
import ServerDown from "./ServerDown";
import DeveloperHelper from "./DeveloperHelper";

import { isAdmin } from "../utils";
import { setActivateAccount } from "../actions/appActions";
import {DebugElement, DebugElementBegin, DebugRoute} from "../Atollon/debug";
import {
    organizationPackageMapping_getRoutePathStringForForNavigationContainer
} from "../Atollon/pages/OrganizationPackageMapping/shared";
import {
    OrganizationPackageMappingAsRedux
} from "../Atollon/pages/OrganizationPackageMapping/OrganizationPackageMapping";
import {HostCategoriesAsRedux} from "../Atollon/pages/HostCategories/HostCategories";
import {ServerCategoriesAsRedux} from "../Atollon/pages/ServerCategories/ServerCategories";
import {hostCategories_getRoutePathStringForForNavigationContainer} from "../Atollon/pages/HostCategories/shared";
import {serverCategories_getRoutePathStringForForNavigationContainer} from "../Atollon/pages/ServerCategories/shared";
import {getPageClass, processPotentialPageLocationChanges} from "../Atollon/Page";
import {searchBarAction} from "../actions/searchBarActions";

const NavigationContainer = props => {
  const { role, location } = props;

  const admin = isAdmin(role);

  if (/activate-account$/.test(window.location.href))
    return <ActivateAccount {...props} />;

  return (
    <div className={getPageClass( location )}>
        <DebugElement text={"NavigationContainer - before Navigation"}/>
      <DebugRoute path={`/server-down`} component={ServerDown} {...props} />
      {location.pathname !== "/server-down" && <Dialogs />}
      {location.pathname !== "/server-down" && (
        <Navigation>
            <DebugElement text={"NavigationContainer - before Switch"}/>
          <Switch>
            <DebugRoute exact path={`/`} component={UserOrganizations} {...props} />
            <DebugRoute exact path={`/dashboard`} component={Main} {...props} />
            <DebugRoute path={`/developer`} component={DeveloperHelper} {...props} />
            <DebugRoute path={`/debug`} component={DeveloperHelper} {...props} />
            <DebugRoute path={`/person/:id`} component={Person} {...props} />
            <DebugRoute path={`/project-new`} component={ProjectNew} {...props} />
            <DebugRoute exact path={`/projects`} component={Projects} {...props} />
            <DebugRoute path={`/projects/:id`} component={Project} {...props} />
            <DebugRoute path={`/requests/:id`} component={RequestDetail} {...props} />
            <DebugRoute path={`/request-new`} component={RequestNew} {...props} />
            <DebugRoute path={`/request-received`} component={RequestReceived} {...props} />
            <DebugRoute path={`/requests-me`} component={RequestsMe} {...props} />
            <DebugRoute path={`/requests-other`} component={RequestsOther} {...props} />
            <DebugRoute path={`/contacts`} component={Contacts} {...props} />
            <DebugRoute path={`/settings`} component={Settings} {...props} />
            <DebugRoute path={`/organization-new`} component={OrganizationNew} {...props} />
            <DebugRoute path={`/suppliers-invite`} component={SuppliersInvite} {...props} />
            <DebugRoute path={`/organizations`} component={UserOrganizations} {...props} />
            {admin && <DebugRoute path={`/hosts`} component={Hosts} {...props} />}
            {admin && (
              <DebugRoute path={`/host-found`} component={HostFound} {...props} />
            )}
            {admin && (
              <DebugRoute path={`/server-found`} component={ServerFound} {...props} />
            )}
            {admin && (
              <DebugRoute path={`/organization-found`} component={OrganizationFound} {...props} />
            )}
            {admin && (
              <DebugRoute path={`/resources`} component={Resources} {...props} />
            )}
            <DebugRoute path={`/remove-host`} component={RemoveHost} {...props} />
            <DebugRoute path={`/remove-server`} component={RemoveServer} {...props} />
            <DebugRoute path={`/remove-organization`} component={RemoveOrganization} {...props} />
              {
                  // Navigation.js + NavigationContainer.js

                  admin &&
                  <DebugRoute path={organizationPackageMapping_getRoutePathStringForForNavigationContainer()} component={OrganizationPackageMappingAsRedux} {...props} />
              }
              {
                  // Navigation.js + NavigationContainer.js

                  admin &&
                  <DebugRoute path={hostCategories_getRoutePathStringForForNavigationContainer()} component={HostCategoriesAsRedux} {...props} />
              }
              {
                  // Navigation.js + NavigationContainer.js

                  admin &&
                  <DebugRoute path={serverCategories_getRoutePathStringForForNavigationContainer()} component={ServerCategoriesAsRedux} {...props} />
              }
            <DebugRoute path={`/package-new`} component={PackageNew} {...props} />
            <DebugRoute path={`/:id`} component={Page} {...props} />
          </Switch>
        </Navigation>
      )}
    </div>
  );
};

export default compose(
  connect(({ app: { role } }) => ({ role }), { setActivateAccount, searchBarAction }),
  withRouter,
  lifecycle({
    async componentWillMount() {
      const { setActivateAccount, history } = this.props;

      if (/^[^?]+\?activateAccount=.+$/.test(window.location.href)) {
        setActivateAccount(window.location.href.match(/=[^=]+$/g)[0].substr(1));
        history.push("/activate-account");
      }
    },

    // Is fired when url changes ( https://github.com/ReactTraining/react-router/issues/4603 ). Should be reliable.
    componentWillReceiveProps() {
      const { setActivateAccount, history, searchBarAction, location } = this.props;
      processPotentialPageLocationChanges( location, searchBarAction );
    }
  })
)(NavigationContainer);



// WEBPACK FOOTER //
// ./src/pages/NavigationContainer.js